import { Image, List } from "antd-mobile"
import { useTranslation } from "react-i18next"
import FeedbackBtns from "./FeedbackBtns"
import ContactDialog from "../../../components/dialog/ContactDialog"
import { useRef } from "react"
import WechatDialog from "../../../components/dialog/WechatDialog"
import InstructionItems from "../Instruction/InstructionItems"
import { useNavigate } from "react-router-dom"

const HotFaq = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const contactDlgRef = useRef(null)
    const wechatDlgRef = useRef(null)

    const handleFeedback = () => {
        window.ReactNativeWebView.postMessage('feedback')
    }

    const handleContact = () => {
        contactDlgRef.current?.show()
    }
    return <div className="tab-content">
        <div style={{ background: 'white', borderRadius: 16 }}>
            <List mode='card'>
                <List.Item onClick={() => {
                    navigate('/bind_device_faq')
                }}>
                    {t('bind_device_faq_title')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/accessory_faq')
                }}>
                    {t('accessory_notice')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/device_unconnect_faq')
                }}>
                    {t('cannot_connect_camera')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('./device_use_faq')
                }}>
                    {t('cannot_use_camera')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('./device_fix_faq')
                }}>
                    {t('how_start_fix')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/sale_service_faq')
                }}>
                    {t('insale')}
                </List.Item>
            </List>
        </div>

        <InstructionItems />
        <FeedbackBtns onFeedbackClick={handleFeedback} onContactClick={handleContact} />
        <ContactDialog ref={contactDlgRef} onPhoneClick={() => {
            window.ReactNativeWebView.postMessage('400-069-0588')
        }} onWechatClick={() => {
            contactDlgRef.current?.dismiss()
            wechatDlgRef.current?.show()
        }} />
        <WechatDialog ref={wechatDlgRef} />
    </div>
}

const styles = {
    cancat: {
        fontSize: 15,
        color: '#4C4C4CCC',
        fontWeight: '500'
    },
}

export default HotFaq